export const ADD    = 'ADD';
export const REMOVE = 'REMOVE';
export const CHANGE = 'CHANGE';